import { render, staticRenderFns } from "./ViewsThankYou.vue?vue&type=template&id=23e4d823&scoped=true&"
import script from "./ViewsThankYou.vue?vue&type=script&lang=js&"
export * from "./ViewsThankYou.vue?vue&type=script&lang=js&"
import style0 from "./ViewsThankYou.vue?vue&type=style&index=0&id=23e4d823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4d823",
  null
  
)

export default component.exports